import { RETURN_TASK, RETURN_TASK_SUCCESSFUL, RETURN_TASK_FAILED } from './actionTypes';

const initialState = {
    registrationTaskError: null, returnTaskMessage: null, loadingReturnTask: false
}

const returnTask = (state = initialState, action) => {
    switch (action.type) {
        case RETURN_TASK:
            state = {
                ...state,
                loadingReturnTask: true,
                registrationTaskError: null
            }
            break;
        case RETURN_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingReturnTask: false,
                returnTaskMessage: action.payload,
                registrationTaskError: null
            }
            break;
        case RETURN_TASK_FAILED:
            state = {
                ...state,
                returnTaskMessage: null,
                loadingReturnTask: false,
                registrationTaskError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default returnTask;